import { TIP_ACTION, TIP_STATUS } from "./constants"

/**
 * What to do with the tip after a card payment, from the payments/record response's `tip`.
 *
 * The tip is a separate charge with its own outcome, so the booking payment succeeding says nothing
 * about it. Kept pure (no Stripe, no dispatch) so every branch can be exercised without a browser.
 *
 * - NONE: nothing to do — no tip was asked for, it was collected, or an older backend sent no
 *   status and nothing to confirm.
 * - CONFIRM: pending with a client_secret — confirm it with Stripe, then capture it.
 * - WARN: the tip was not collected and cannot be confirmed here — tell the guide.
 */
export const getTipAction = (tip, tipAmount) => {
  if (!tip || !(Number(tipAmount) > 0)) return TIP_ACTION.NONE
  const status = String(tip.status || "").toLowerCase()
  if (status === TIP_STATUS.COMPLETED) return TIP_ACTION.NONE
  // A backend that predates tip.status only sends a client_secret when the tip needs confirming.
  const isPending = status === TIP_STATUS.PENDING || (!status && Boolean(tip.client_secret))
  if (!status && !isPending) return TIP_ACTION.NONE
  return isPending && tip.client_secret ? TIP_ACTION.CONFIRM : TIP_ACTION.WARN
}
